import React from "react";
import "./SavvyStatus.css";

// ------------------------------------------------------------------ //
// Component                                                            //
// ------------------------------------------------------------------ //

const SavvyStatus = ({ queueCount, portfolioValue, committedCapital, marketOpen }) => {
    const utilPct =
        portfolioValue && committedCapital
            ? Math.min(100, Math.round((committedCapital / portfolioValue) * 100))
            : 0;

    const marketKey   = marketOpen === null ? "unknown" : marketOpen ? "open" : "closed";
    const marketLabel = marketOpen === null ? "Checking market…"
                      : marketOpen           ? "Market open"
                      :                        "Market closed";

    return (
        <div className="savvy-status">
            {/* Market status */}
            <div className="ss-item">
                <span className={`ss-dot ss-dot--${marketKey}`} />
                <span className="ss-label">{marketLabel}</span>
            </div>

            {/* Queue count — only shown when orders exist */}
            {queueCount > 0 && (
                <>
                    <div className="ss-divider" />
                    <div className="ss-item">
                        <span className="ss-count">{queueCount}</span>
                        <span className="ss-label">
                            {queueCount === 1 ? "trade queued" : "trades queued"}
                        </span>
                    </div>
                </>
            )}

            {/* Capital utilization — only shown when data is available */}
            {utilPct > 0 && (
                <>
                    <div className="ss-divider" />
                    <div className="ss-item">
                        <span
                            className={`ss-pct ${
                                utilPct >= 60 ? "ss-pct--high" :
                                utilPct >= 30 ? "ss-pct--mid"  : ""
                            }`}
                        >
                            {utilPct}%
                        </span>
                        <span className="ss-label">capital used</span>
                    </div>
                </>
            )}
        </div>
    );
};

export default SavvyStatus;
